export * from './passportInfo.component';
